export function PatientAvatar({ name, size = 28 }: { name: string; size?: number }) {
  const initials = name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  const colors = [
    { bg: 'bg-blue-100', text: 'text-blue-800' },
    { bg: 'bg-amber-100', text: 'text-amber-800' },
    { bg: 'bg-pink-100', text: 'text-pink-800' },
    { bg: 'bg-green-100', text: 'text-green-800' },
    { bg: 'bg-purple-100', text: 'text-purple-800' },
  ];
  const idx = name.charCodeAt(0) % colors.length;
  const color = colors[idx];

  return (
    <div
      className={`${color.bg} ${color.text} rounded-full flex items-center justify-center font-medium shrink-0`}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {initials}
    </div>
  );
}
